import { ReactComponent as ListIcon } from 'assets/icons/check-list.svg';

const Plan = ({ list, title }) => (
    <div className="product-price-plans">
        <div className="body2">{title}</div>
        <ul>
            {list.map((item, index) => (
                <li key={index} className="body2">
                    <ListIcon />
                    <span>{item.text}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default Plan;
